<template>
  <div class="d-flex">
    <div style="min-width: 100px; max-width: 100px"></div>

    <div class="flex d-flex justify-space-between">
      <div class="pt-2">
        {{ label }}
      </div>

      <div class="d-flex justify-end gap-16">
        <div
            v-if="summary"
            class="pt-2 text-end"
            style="min-width: 150px; max-width: 150px"
        >
          {{ formatNumber(field) }}
        </div>
        <TextField
            v-else
            theme="3"
            input-type="decimal"
            :value="field"
            :readonly="readonly"
            @onChange="eventChange"
        ></TextField>

        <div class="pt-2" style="min-width: 130px">
          {{ unit }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TextField from "./input/TextField"
import { formatNumber } from "../plugins/global-funcs"

export default {
  name: "OOILineField",
  components: {
    TextField
  },
  props: {
    field: {
      default: ''
    },
    label: {
      default: ''
    },
    readonly: {
      default: false
    },
    unit: {
      default: 'ราย'
    },
    summary: {
      default: false
    }
  },
  data () {
    return {
      formatNumber
    }
  },
  methods: {
    eventChange (val) {
      this.$emit('onChange', val)
    }
  }
}
</script>

<style scoped>

</style>